import { useFeatureFlagEnabled } from '@frameio/feature-flags';

export const useIsAccessRequestsEnabled = () => {
  const isAccessRequestsEnabled = useFeatureFlagEnabled('v4.access_requests');

  return isAccessRequestsEnabled;
};
